import template from './sw-cms-preview-acris-blog-product-slider.html.twig';
import './sw-cms-preview-acris-blog-product-slider.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-product-slider', {
    template
});
